import React, { useState } from 'react';
import { View } from 'react-native';
import type { Meta, StoryObj } from '@storybook/react';

import { JournalEntryData } from './ContainJournalEntry';
import { PresentJournalEntry } from './PresentJournalEntry';

const data = (value: string, onChangeText: (value: string) => void = () => undefined): JournalEntryData => ({
  value,
  onChangeText,
});

const meta = {
  title: 'Diary/Frames/JournalEntry',
  component: PresentJournalEntry,
  args: {
    questionId: 'story-journal',
    questionText: 'What are you grateful for today?',
    margin: 16,
    data: data(''),
  },
  decorators: [
    Story => (
      <View style={{ width: 375, height: 560 }}>
        <Story />
      </View>
    ),
  ],
} satisfies Meta<typeof PresentJournalEntry>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Empty: Story = {};

export const WithHelperCard: Story = {
  args: {
    data: {
      ...data('A calm morning walk before work.'),
      infoTitle: 'How to do it',
      infoBody: 'Write down three things you are grateful for. Small things count.',
    },
  },
};

const InteractiveJournalEntry = (args: React.ComponentProps<typeof PresentJournalEntry>) => {
  const [value, setValue] = useState('');
  return (
    <View style={{ width: 375, height: 560 }}>
      <PresentJournalEntry {...args} data={data(value, setValue)} />
    </View>
  );
};

export const Interactive: Story = {
  render: args => <InteractiveJournalEntry {...args} />,
};
